<svg class="{{ name }}" [ngStyle]="customStyle">
  <use [attr.xlink:href]="'#' + name"></use>
</svg>
